<template>
	<div>
		<vue2-tinymce-editor
			v-if="!loadingMce"
			:inline="true"
			v-model="localTextContent"
			:options="options"
			ref="tinymceEditor"></vue2-tinymce-editor>
	</div>
</template>

<script>
import { Vue2TinymceEditor } from "vue2-tinymce-editor"
import {fileUploadToReport} from '@/helpers/api/files'
import { placeholderMapping } from '@/components/Helpers/Constants/contract'

export default {
  name: 'ContractTinyMCE',
  components: { Vue2TinymceEditor },
	props: {
		textContent: {
			Type: String,
			required: true
		},
		simpleEditor: {
			Type: Boolean,
			required: false
		},
	},
  data: () => ({
		placeholderMapping,
		loadingMce: true,
		localTextContent: null,
		isUpdatingContent: false,
		inputTimeout: null,
		options: null
  }),
  computed: {
  },
	watch: {
		localTextContent(newValue){
			this.$emit('update:textContent', newValue);
		}
	},
  mounted(){
		this.localTextContent = this.textContent
		this.options =  {
			plugins: 'paste image imagetools',
			language: 'es',
			language_url: 'https://cdn.tiny.cloud/1/no-api-key/tinymce/5/langs/es.js',
			font_formats: 'Archivo Narrow=system-ui; Andale Mono=andale mono,times; Arial=arial,helvetica,sans-serif; Arial Black=arial black,avant garde; Book Antiqua=book antiqua,palatino; Comic Sans MS=comic sans ms,sans-serif; Courier New=courier new,courier; Georgia=georgia,palatino; Helvetica=helvetica; Impact=impact,chicago; Symbol=symbol; Tahoma=tahoma,arial,helvetica,sans-serif; Terminal=terminal,monaco; Times New Roman=times new roman,times; Trebuchet MS=trebuchet ms,geneva; Verdana=verdana,geneva; Webdings=webdings; Wingdings=wingdings,zapf dingbats',
			toolbar: 'undo redo | fontselect fontsizeselect addVariableButton | styleselect bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | table',
			content_style: `@import url('https://fonts.googleapis.com/css2?family=Archivo+Narrow:ital,wght@0,400..700;1,400..700&display=swap');`,
			content_css: `
				.friendly-placeholder {
					color: #007bff;
					background-color: #e9f7ff;
					padding: 2px 4px;
					border-radius: 4px;
					font-style: italic;
				}
			`,
			automatic_uploads: true,
			setup: this.setupTiny,
			images_upload_handler: this.uploadImageFromTiny,
			file_picker_callback: this.filePickerTiny
		}
		if(this.simpleEditor){
			console.log('simpleEditor')
			this.options = {...this.options,...{
				plugins: null,
				font_formats: null,
				toolbar: 'addVariableButton',
				menubar: false,
			}}
		}
		this.$nextTick(() => {
			this.loadingMce = false
		});
  },
  methods: {
		transformPlaceholdersToFriendlyView(content) {
			let result = content;
			for (const [placeholder, label] of Object.entries(this.placeholderMapping)) {
				const regex = new RegExp(placeholder, 'g');
				result = result.replace(regex, `<span class="friendly-placeholder" style="font-size: 12px;padding: 1px 6px;border: 1px solid grey;border-radius: 5px;background: white;color:orange;" contenteditable="false">${label}</span>`);
			}
			return result;
		},
		transformFriendlyViewToPlaceholders(content) {
			let result = content;
			for (const [placeholder, label] of Object.entries(this.placeholderMapping)) {
				const escapeRegExp = (text) => text.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

				const normalizeLabelForRegex = (text) => {
						return text.replace(/á/g, '(á|&aacute;)')
											.replace(/é/g, '(é|&eacute;)')
											.replace(/í/g, '(í|&iacute;)')
											.replace(/ó/g, '(ó|&oacute;)')
											.replace(/ú/g, '(ú|&uacute;)')
											.replace(/ñ/g, '(ñ|&ntilde;)');
				};

				const regex = new RegExp(`<span class="friendly-placeholder"[^>]*>${normalizeLabelForRegex(escapeRegExp(label))}</span>`, 'g');
				result = result.replace(regex, placeholder);
			}
			return result;
		},
		uploadImageFromTiny(file, succes, failure){
			const formData = new FormData();
			formData.append('file', file.blob());

			fileUploadToReport(formData)
				.then((uploaded_file) => {
					if (uploaded_file.code === 200) {
						succes(uploaded_file.url);
					} else {
						failure(new Error(`Error: ${uploaded_file.code}`));
					}
				})
				.catch((error) => {
					failure(error);
				});
		},
		filePickerTiny(callback) {
			const input = this.$refs.fileInput;
			input.onchange = async (event) => {
				const file = event.target.files[0];
				const formData = new FormData();
				formData.append('file', file);
				try {
					const uploaded_file = await fileUploadToReport(formData);
					if (uploaded_file.code === 200) {
						const url = uploaded_file.url;
						callback(url, { alt: file.name });
					} else {
						console.error('Error al subir la imagen:', uploaded_file.message);
					}
				} catch (error) {
					console.error('Error en la subida de la imagen:', error);
				}
			};
			input.click();
		},
		preserveCursorPosition(editor, callback) {
			const selection = editor.selection;
			// const range = selection.getRng();
			const bookmark = selection.getBookmark(2, true);
			
			callback();
			
			this.$nextTick(() => {
				try {
					selection.moveToBookmark(bookmark);
				} catch (error) {
					editor.selection.select(editor.getBody(), true);
					editor.selection.collapseToEnd();
				}
			});
		},
		setupTiny(editor){
			editor.on('init', () => {
				const content = editor.getContent();
				const transformedContent = this.transformPlaceholdersToFriendlyView(content);
				editor.setContent(transformedContent);
			})

			editor.on('ExecCommand', (e) => {
				if (e.command === 'mceInsertContent') {
					setTimeout(() => {
						if (this.isUpdatingContent) return;
						
						this.isUpdatingContent = true;
						
						const content = editor.getContent();
						const updatedContent = this.transformPlaceholdersToFriendlyView(content);
						
						if (updatedContent !== content) {
							const selection = editor.selection;
							// const currentRange = selection.getRng();
							
							editor.setContent(updatedContent);
							
							this.$nextTick(() => {
								const placeholders = editor.dom.select('.friendly-placeholder');
								if (placeholders.length > 0) {
									const lastPlaceholder = placeholders[placeholders.length - 1];
									const range = editor.dom.createRng();
									range.setStartAfter(lastPlaceholder);
									range.setEndAfter(lastPlaceholder);
									selection.setRng(range);
								}
							});
						}
						
						this.isUpdatingContent = false;
					}, 50);
				}
			});

			editor.on('input', () => {
				if (this.isUpdatingContent) return;
				
				if (this.inputTimeout) {
					clearTimeout(this.inputTimeout);
				}
				
				this.inputTimeout = setTimeout(() => {
					this.isUpdatingContent = true;
					
					const content = editor.getContent();
					const updatedContent = this.transformPlaceholdersToFriendlyView(content);
					
					if (updatedContent !== content) {
						this.preserveCursorPosition(editor, () => {
							editor.setContent(updatedContent);
						});
					}
					
					this.isUpdatingContent = false;
				}, 100);
			});
			
			editor.on('keydown', (e) => {
				if (this.isUpdatingContent) return;
				
				const isValidKey = (
					(e.keyCode >= 48 && e.keyCode <= 57) ||
					(e.keyCode >= 65 && e.keyCode <= 90) ||
					e.keyCode === 32 ||
					e.keyCode === 8 ||
					e.keyCode === 46
				);
				
				if (!isValidKey) return;
				
				setTimeout(() => {
					if (this.isUpdatingContent) return;
					
					this.isUpdatingContent = true;
					
					const content = editor.getContent();
					const updatedContent = this.transformPlaceholdersToFriendlyView(content);
					
					if (updatedContent !== content) {
						this.preserveCursorPosition(editor, () => {
							editor.setContent(updatedContent);
						});
					}
					
					this.isUpdatingContent = false;
				}, 10);
			});
			editor.on('GetContent', (event) => {
				const originalContent = this.transformFriendlyViewToPlaceholders(event.content);
				event.content = originalContent;
			})
			
      editor.ui.registry.addMenuButton('addVariableButton', {
        text: 'Insertar Variable',
        icon: 'paste-text',
				fetch: (callback) => {
					const items = [
						{
							type: 'nestedmenuitem',
							text: 'Cliente',
							getSubmenuItems: () => [
								{
									type: 'menuitem',
									text: 'Nombre Cliente',
									onAction: () => editor.insertContent('{client_name}')
								},
								{
									type: 'menuitem',
									text: 'Rut Cliente',
									onAction: () => editor.insertContent('{client_dni}')
								},
								{
									type: 'menuitem',
									text: 'Dirección Cliente',
									onAction: () => editor.insertContent('{client_address}')
								},
								{
									type: 'menuitem',
									text: 'Comuna Cliente',
									onAction: () => editor.insertContent('{client_district}')
								}
							]
						},
						{
							type: 'nestedmenuitem',
							text: 'Cliente Empresa',
							getSubmenuItems: () => [
								{
									type: 'menuitem',
									text: 'Nombre Empresa',
									onAction: () => editor.insertContent('{client_company_name}')
								},
								{
									type: 'menuitem',
									text: 'Rut Empresa',
									onAction: () => editor.insertContent('{client_company_dni}')
								},
								{
									type: 'menuitem',
									text: 'Dirección Empresa',
									onAction: () => editor.insertContent('{client_company_address}')
								},
								{
									type: 'menuitem',
									text: 'Comuna Empresa',
									onAction: () => editor.insertContent('{client_company_district}')
								},
								{
									type: 'menuitem',
									text: 'Nombre Representante',
									onAction: () => editor.insertContent('{client_rep_name}')
								},
								{
									type: 'menuitem',
									text: 'Rut Representante',
									onAction: () => editor.insertContent('{client_rep_dni}')
								},
								{
									type: 'menuitem',
									text: 'Dirección Representante',
									onAction: () => editor.insertContent('{client_rep_address}')
								},
								{
									type: 'menuitem',
									text: 'Comuna Representante',
									onAction: () => editor.insertContent('{client_rep_district}')
								}
							]
						},
						{
							type: 'nestedmenuitem',
							text: 'Proyectos',
							getSubmenuItems: () => [
								{
									type: 'menuitem',
									text: 'Fecha del Contrato',
									onAction: () => editor.insertContent('{contract_date}')
								},
								{
									type: 'menuitem',
									text: 'Fecha Inicio del Proyecto',
									onAction: () => editor.insertContent('{contract_start_date}')
								},
								{
									type: 'menuitem',
									text: 'Dirección del Proyecto',
									onAction: () => editor.insertContent('{address}')
								},
								{
									type: 'menuitem',
									text: 'Municipio del Proyecto',
									onAction: () => editor.insertContent('{district}')
								},
								{
									type: 'menuitem',
									text: 'Costo Mofificación Proyecto',
									onAction: () => editor.insertContent('{project_modification_value_uf}')
								}
							]
						},
						{
							type: 'nestedmenuitem',
							text: 'Tabla de Costo',
							getSubmenuItems: () => [
								{
									type: 'menuitem',
									text: 'Resumen Tabla de Costos',
									onAction: () => editor.insertContent('{cost_table_summary}')
								},
								{
									type: 'menuitem',
									text: 'Etapas (Pagos) Tabla de Costos',
									onAction: () => editor.insertContent('{cost_table_payments}')
								}
							]
						},
						{
							type: 'nestedmenuitem',
							text: 'Empresa',
							getSubmenuItems: () => [
								{
									type: 'menuitem',
									text: 'Nombre',
									onAction: () => editor.insertContent('{company_name}')
								},
								{
									type: 'menuitem',
									text: 'Rut',
									onAction: () => editor.insertContent('{company_rut}')
								},
								{
									type: 'menuitem',
									text: 'Nombre Representante',
									onAction: () => editor.insertContent('{company_responsible}')
								},
								{
									type: 'menuitem',
									text: 'Rut Representante',
									onAction: () => editor.insertContent('{company_responsible_rut}')
								},
								{
									type: 'menuitem',
									text: 'Dirección',
									onAction: () => editor.insertContent('{company_address}')
								},
								{
									type: 'menuitem',
									text: 'Cuenta Bancaria',
									onAction: () => editor.insertContent('{company_bank_account_html}')
								}
							]
						},
					];
					callback(items);
				}
      })

			editor.on('paste', (e) => {
				const clipboard = e.clipboardData || e.originalEvent.clipboardData
				
					if (clipboard && clipboard.items) {
						let pastedContent = '';
						let imageCounter = 0;

						const handleItem = (item) => {
								return new Promise((resolve) => {
										if (item.type.indexOf('image') !== -1) {
												const file = item.getAsFile();
												const formData = new FormData();
												formData.append('file', file);

												fileUploadToReport(formData)
														.then((uploaded_file) => {
																if (uploaded_file.code == 200) {
																		const url = uploaded_file.url;
																		pastedContent += `<img src="${url}" />`;
																}
																resolve();
														});
										} else if (item.type === 'text/html') {
												item.getAsString((htmlContent) => {
														const parser = new DOMParser();
														const doc = parser.parseFromString(htmlContent, 'text/html');
														const images = doc.querySelectorAll('img');

														if (images.length > 0) {
															images.forEach((img, index) => {
																if (img.src.startsWith('data:image')) {
																	const base64Data = img.src.split(',')[1];
																	const contentType = img.src.split(';')[0].split(':')[1];

																	const byteCharacters = atob(base64Data);
																	const byteNumbers = new Array(byteCharacters.length);
																	for (let i = 0; i < byteCharacters.length; i++) {
																		byteNumbers[i] = byteCharacters.charCodeAt(i);
																	}

																	const byteArray = new Uint8Array(byteNumbers);
																	const blob = new Blob([byteArray], { type: contentType });
																	const file = new File([blob], `image${imageCounter}.png`, { type: contentType });

																	const formData = new FormData();
																	formData.append('file', file);
																	imageCounter++;

																	fileUploadToReport(formData)
																		.then((uploaded_file) => {
																			if (uploaded_file.code == 200) {
																				img.src = uploaded_file.url;
																			}
																			if (index === images.length - 1) {
																				pastedContent += doc.body.innerHTML;
																				resolve();
																			}
																		});
																} else {
																	pastedContent += doc.body.innerHTML;
																	resolve();
																}
															});
														} else {
																pastedContent += htmlContent;
																resolve();
														}
												});
										} else if (item.type === 'text/plain') {
												item.getAsString((plainText) => {
														pastedContent += plainText;
														resolve();
												});
										} else {
												resolve();
										}
								});
						};

						const processItemsSequentially = async () => {
								for (let i = 0; i < clipboard.items.length; i++) {
										await handleItem(clipboard.items[i]);
								}
								editor.execCommand('mceInsertContent', false, pastedContent);
						};

						processItemsSequentially();
					}
			})
		},
  }
};
</script>
<style>
  .friendly-placeholder {
    color: #007bff;
    background-color: #e9f7ff;
    padding: 2px 4px;
    border-radius: 4px;
    font-style: italic;
  }
</style>
<style scoped>
	.profile-avatar{
		cursor: pointer;
	}
  .info-container{
    color: #606060;
  }
  .text-primary{
    color: #524D4D;
  }
  .info-icon{
    background-color: #524D4D;
    border-radius: 25px;
    padding: 3px;
    width: 35px;
    height: 35px;
  }
  .info-icon.small-icon{
    width: 25px;
    height: 25px;
  }
  .info-img{
    width: 100%;
    max-height: 50px;
    object-fit: contain;
  }
  .adjuntos-container{
    background-color: #EFEFEF;
    max-height: 95px;
    overflow-y: scroll;
  }
  .interaction-container{
    width: 100%;
    background-color: #E5E9F2;
    border-radius: 5px;
    position: relative;
    padding: 12px;
  }
  .user-avatar.small{
    width: 25px;
    height: 25px;
  }
  .light-blue-text{color: #959595;}
  .interaction-container .icon-arrow{
    font-size: 80px;
    position: absolute;
    top: 20px;
    line-height: inherit;
  }
  .interaction-container.right .icon-arrow{
    left: -46px;
  }
  .interaction-container.left .icon-arrow{
    right: -46px;
  }
	.friendly-placeholder{
		background: red;
	}
  /deep/ .custom-input-numbers .v-input__slot{padding:0!important;}
  /deep/ .custom-input-numbers .v-input__prepend-inner,
  /deep/ .custom-input-numbers .v-input__append-inner,
  /deep/ .custom-text-input .v-input__append-inner{margin-top:0!important;}
  /deep/ .custom-input-numbers input {text-align: center }
</style>